import type Picture from '$lib/components/atoms/image/Picture.svelte';
import type { SupportedLocale } from '@viamichelin/business';
import type { ComponentProps } from 'svelte';
import mobileAvifImage from '$assets/contest/contest-w320.avif';
import mobileWebpImage from '$assets/contest/contest-w320.webp';

import desktopAvifImage from '$assets/contest/contest-w960.avif';
import desktopWebpImage from '$assets/contest/contest-w960.webp';
import { env } from '$env/dynamic/public';
import { matchGuardByLocaleAndDates } from '$lib/utils/matchGuards';

export interface MarketingEventConfig {
	enabled: boolean;
	maxNbOpening: number;
	storageKey: string;
	pictureProps: ComponentProps<typeof Picture>;
	redirectTo: string;
	matchGuard: (locale: SupportedLocale) => boolean;
}

const isMarketingModalEnabled = Boolean(env?.PUBLIC_MARKETING_MODAL_ENABLED);
const [startDate, endDate, enabledLocale = 'fr-FR'] = env?.PUBLIC_MARKETING_MODAL_ENABLED?.split(',') || [];

export const marketingEvent = {
	enabled: isMarketingModalEnabled,
	maxNbOpening: 3,
	storageKey: 'marketingModalNbOpen',
	redirectTo: '/profile/animation',
	pictureProps: {
		alt: 'Jeu de l\'été, connectez-vous ou créez un compte pour participer et gagner l\'expérience de votre choix d\'une valeur de 200€ avec Get Your Guide',
		width: '320',
		height: '500',
		src: mobileWebpImage,
		eager: true,
		sources: [
			{ srcset: `${mobileAvifImage} 320w`, media: '(max-width: 959px)', type: 'image/avif' },
			{ srcset: `${desktopAvifImage} 471w`, media: '(min-width: 960px)', type: 'image/avif' },
			{ srcset: `${mobileWebpImage} 320w`, media: '(max-width: 959px)', type: 'image/webp' },
			{ srcset: `${desktopWebpImage} 471w`, media: '(min-width: 960px)', type: 'image/webp' },
		],
	},
	matchGuard: (locale: SupportedLocale) => matchGuardByLocaleAndDates(startDate, endDate, locale, enabledLocale as SupportedLocale),
} satisfies MarketingEventConfig;
